<template>
  <keep-alive include="LabelList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "coveShedAddress",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
